"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollectionWriter = void 0;
var tslib_1 = require("tslib");
var form_field_1 = require("../fields/form.field");
var capture_provider_1 = require("../fields/provider/capture.provider");
var collection_model_write_brightnessCorrection_1 = require("./collection.model.write.brightnessCorrection");
var collection_model_write_cropParameter_1 = require("./collection.model.write.cropParameter");
var collection_model_write_drawable_1 = require("./collection.model.write.drawable");
var collection_model_write_field_1 = require("./collection.model.write.field");
var collection_model_write_imageVisibility_1 = require("./collection.model.write.imageVisibility");
var MEASUREMENT_STATE_TYPE = 'truesize';
var IkeModelCollectionWriter = /** @class */ (function () {
    function IkeModelCollectionWriter() {
    }
    IkeModelCollectionWriter.writeField = function (collectionField) {
        return collection_model_write_field_1.FieldWriters[collectionField.schema.type](collectionField);
    };
    IkeModelCollectionWriter.writeData = function (instance) {
        var e_1, _a;
        var instanceData = {
            _id: instance.instanceId
        };
        try {
            for (var _b = tslib_1.__values(instance.schema.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var schemaField = _c.value;
                if (!instance.hasField(schemaField.id)) {
                    continue;
                }
                var field = instance.getField(schemaField.id);
                if (form_field_1.CollectionModelFieldSubForm.isSubFormField(field)) {
                    instanceData[schemaField.id] = field.value.map(function (ins) { return IkeModelCollectionWriter.writeData(ins); });
                }
                else if (field.hasValue()) {
                    instanceData[schemaField.id] = IkeModelCollectionWriter.writeField(field);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return instanceData;
    };
    IkeModelCollectionWriter.writeCollectionMeasurements = function (model) {
        var e_2, _a, e_3, _b;
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        try {
            for (var captures_1 = tslib_1.__values(captures), captures_1_1 = captures_1.next(); !captures_1_1.done; captures_1_1 = captures_1.next()) {
                var captureId = captures_1_1.value;
                var capture = model.state.getCapture(captureId);
                if (capture == null) {
                    continue;
                }
                var state = model.getDrawableState(captureId);
                var _loop_1 = function (drawable) {
                    output[captureId] = output[captureId] || { state: [], type: MEASUREMENT_STATE_TYPE, captureId: captureId };
                    if (output[captureId].state.find(function (existing) { return existing.id === drawable.id; })) {
                        return "continue";
                    }
                    var val = collection_model_write_drawable_1.DrawableWriter.write(model, drawable);
                    if (val == null) {
                        return "continue";
                    }
                    output[captureId].state.push(val);
                    output[captureId].captureId = captureId;
                };
                try {
                    for (var _c = (e_3 = void 0, tslib_1.__values(state.values())), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var drawable = _d.value;
                        _loop_1(drawable);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (captures_1_1 && !captures_1_1.done && (_a = captures_1.return)) _a.call(captures_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return output;
    };
    IkeModelCollectionWriter.writeCollectionBrightnessCorrections = function (model) {
        var e_4, _a, e_5, _b;
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        try {
            for (var captures_2 = tslib_1.__values(captures), captures_2_1 = captures_2.next(); !captures_2_1.done; captures_2_1 = captures_2.next()) {
                var captureId = captures_2_1.value;
                var capture = model.state.getCapture(captureId);
                if (capture == null) {
                    continue;
                }
                var state = model.getBrightnessCorrectionState(captureId);
                var _loop_2 = function (brightnessCorrection) {
                    output[captureId] = output[captureId] || { state: [], type: capture.type, captureId: captureId };
                    if (output[captureId].state.find(function (existing) { return existing.id === brightnessCorrection.id; })) {
                        return "continue";
                    }
                    var val = collection_model_write_brightnessCorrection_1.BrightnessCorrectionWriter.write(brightnessCorrection);
                    if (val == null) {
                        return "continue";
                    }
                    output[captureId].state.push(val);
                    output[captureId].captureId = captureId;
                };
                try {
                    for (var _c = (e_5 = void 0, tslib_1.__values(state.values())), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var brightnessCorrection = _d.value;
                        _loop_2(brightnessCorrection);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (captures_2_1 && !captures_2_1.done && (_a = captures_2.return)) _a.call(captures_2);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return output;
    };
    IkeModelCollectionWriter.writeImageVisibilities = function (model) {
        var e_6, _a;
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        try {
            for (var captures_3 = tslib_1.__values(captures), captures_3_1 = captures_3.next(); !captures_3_1.done; captures_3_1 = captures_3.next()) {
                var captureId = captures_3_1.value;
                var capture = model.state.getCapture(captureId);
                if (capture == null) {
                    continue;
                }
                var state = model.getImageVisibilityState(captureId);
                if (state.hasImageVisibility()) {
                    var imageVisibility = state.getImageVisibility();
                    output[captureId] = output[captureId] || { state: undefined, type: capture.type, captureId: captureId };
                    output[captureId].state = collection_model_write_imageVisibility_1.ImageVisibilityWriter.write(imageVisibility);
                    output[captureId].captureId = captureId;
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (captures_3_1 && !captures_3_1.done && (_a = captures_3.return)) _a.call(captures_3);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return output;
    };
    IkeModelCollectionWriter.writeCollectionCropParameters = function (model) {
        var e_7, _a, e_8, _b;
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        try {
            for (var captures_4 = tslib_1.__values(captures), captures_4_1 = captures_4.next(); !captures_4_1.done; captures_4_1 = captures_4.next()) {
                var captureId = captures_4_1.value;
                var capture = model.state.getCapture(captureId);
                if (capture == null) {
                    continue;
                }
                var state = model.getCropParameterState(captureId);
                var _loop_3 = function (cropParameter) {
                    output[captureId] = output[captureId] || { state: [], type: capture.type, captureId: captureId };
                    if (output[captureId].state.find(function (existing) { return existing.id === cropParameter.id; })) {
                        return "continue";
                    }
                    var val = collection_model_write_cropParameter_1.CropParameterWriter.write(cropParameter);
                    if (val == null) {
                        return "continue";
                    }
                    output[captureId].state.push(val);
                    output[captureId].captureId = captureId;
                };
                try {
                    for (var _c = (e_8 = void 0, tslib_1.__values(state.values())), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var cropParameter = _d.value;
                        _loop_3(cropParameter);
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (captures_4_1 && !captures_4_1.done && (_a = captures_4.return)) _a.call(captures_4);
            }
            finally { if (e_7) throw e_7.error; }
        }
        return output;
    };
    return IkeModelCollectionWriter;
}());
exports.IkeModelCollectionWriter = IkeModelCollectionWriter;
//# sourceMappingURL=collection.model.write.js.map